import type { FC, ReactNode } from 'react';
import { Inbox } from 'lucide-react';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

/**
 * Showcase §5 表格/面板空态。
 * 表格区域需水平+垂直居中时：自定义容器加 `ipc-empty-host`；
 * antd Table 用 `locale.emptyText={<IpcEmpty />}` 即可（占位行已有公共样式）。
 */
export const IpcEmpty: FC<Props> = ({
  title = '暂无匹配数据',
  description = '尝试调整筛选条件或重置查询',
  icon,
  className,
}) => (
  <div className={['ipc-empty', className].filter(Boolean).join(' ')}>
    <span className="ipc-empty__icon" aria-hidden>
      {icon ?? <Inbox size={32} />}
    </span>
    <p className="ipc-empty__title">{title}</p>
    {description != null && description !== '' && (
      <p className="ipc-empty__desc">{description}</p>
    )}
  </div>
);
